
export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#2C2C2C] text-white py-12 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <img
              src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/3d68618d053fb0ce08e1408aabac2d46.png"
              alt="Luxury Products by Maram"
              className="h-16 w-auto mb-4"
            />
            <p className="text-white/90 leading-relaxed mb-4">
              اختيار شخصي لقطع فاخرة، أختارها بذوقي وأقدّمها بثقة.
              كل قطعة تحمل قصة من الأناقة والرقي.
            </p>
            <div className="flex gap-3">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full hover:bg-white/30 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://wa.me/966501234567"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full hover:bg-white/30 transition-colors cursor-pointer"
              >
                <i className="ri-whatsapp-line text-lg"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full hover:bg-white/30 transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">روابط سريعة</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('hero')}
                  className="text-white/80 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  الرئيسية
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('categories')}
                  className="text-white/80 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  الأقسام
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('featured')}
                  className="text-white/80 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  المنتجات المميزة
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('story')}
                  className="text-white/80 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  قصتي
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-white/80 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  تواصلي معي
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4">تواصلي معنا</h3>
            <ul className="space-y-3 text-white/80">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-1"></i>
                <span className="text-sm">info@luxuryproductsbymaram.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line mt-1"></i>
                <span className="text-sm" dir="ltr">+966 50 123 4567</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-1"></i>
                <span className="text-sm">السبت - الخميس<br />10:00 ص - 8:00 م</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-6 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-white/80">
          <p>© 2024 Luxury Products by Maram. جميع الحقوق محفوظة.</p>
          <div className="flex gap-6">
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">
              Powered by AAIT
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
